/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_No_Text_FoundInputs */



/**
* | output |
* | --- |
* | "No text was detected in the video." |
*
* @param {Ocr_No_Text_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_no_text_found = /** @type {((inputs?: Ocr_No_Text_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_No_Text_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun texte n'a été détecté dans la vidéo.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Video wurde kein Text erkannt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nel video non è stato rilevato alcun testo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В видеоролике текст не обнаружен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se detectó texto en el vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频中未检测到任何文字。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画内にテキストは検出されませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में कोई टेक्स्ट नहीं मिला।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum texto foi detectado no vídeo.")
	return /** @type {LocalizedString} */ ("No text was detected in the video.")
});